"use client";

import { useSettingProductTileIterationInTreatment } from "@faire/retailer-visitor-shared/settings/useSettingProductTileIteration";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";

import { ClientFormatMoneyPriceWrapperProps } from "../../../ComposableProductTile/__internal__/__internal__/components/ProductInfo/PriceText/ClientFormatMoneyPriceWrapperProps";
import { PriceWithClientFormatMoney } from "../../../ComposableProductTile/__internal__/__internal__/components/ProductInfo/PriceText/PriceWithClientFormatMoney";
import { ProductName } from "../../../ComposableProductTile/__internal__/__internal__/components/ProductInfo/ProductName";
import { ProductTileSwatches } from "../../../ComposableProductTile/__internal__/__internal__/ProductTileSwatches";
import { ProductTileSwatchesProps } from "../../types";

import { ProductLink } from "./ProductLink";

export const ProductTileNameAndPrice = ({
  priceTextProps,
  productName,
  productTileSwatchesProps,
}: {
  priceTextProps?: ClientFormatMoneyPriceWrapperProps;
  productName: string;
  productTileSwatchesProps?: ProductTileSwatchesProps;
}) => {
  const showTileIterationChanges = useSettingProductTileIterationInTreatment();
  return (
    <ProductLink dataTestId="product-tile-product-information">
      <Spacer
        size={{
          mobileAndAbove: "1x",
          tabletAndAbove: showTileIterationChanges ? "1x" : 12,
        }}
      />
      <Column gap={showTileIterationChanges ? 2 : 0}>
        {priceTextProps && priceTextProps?.isLoggedInOrBrandPreview ? (
          <PriceWithClientFormatMoney {...priceTextProps} />
        ) : null}
        <ProductName productName={productName} />
        {priceTextProps && !priceTextProps?.isLoggedInOrBrandPreview ? (
          <PriceWithClientFormatMoney {...priceTextProps} />
        ) : null}
        <ProductTileSwatches
          optionDetails={productTileSwatchesProps?.optionDetails}
        />
      </Column>
    </ProductLink>
  );
};
